import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Title from './components/Title';
import Music from './components/Music';
import AlbumsOfTheYear from './components/AlbumsOfTheYear';
import Photos from './components/Photos';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import PhotoRedirect from './components/PhotoRedirect'; // New import
import PageNotFound from './components/PageNotFound';
import Map from './components/Map';
import TrainUtil from './components/TrainUtil';
import { usePageTracking } from './hooks/usePageTracking';
import './App.css';

function AppContent() {
  usePageTracking();

  return (
    <div className="App">
      <Navigation />
      <div className="main-view">
        <Routes>
          <Route path="/title" element={<Title />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/music/albums-of-the-year" element={<AlbumsOfTheYear />} />
          <Route path="/albums-of-the-year" element={<AlbumsOfTheYear />} />
          <Route path="/music" element={<Music />} />
          <Route path="/music/:artist" element={<Music />} />
          <Route path="/photos" element={<Photos />} />
          <Route path="/photos/:album" element={<Photos />} />
          <Route path="/photos/id/:id" element={<PhotoRedirect />} /> {/* New Route */}
          <Route path="/pagenotfound" element={<PageNotFound />} />
          <Route path="/map" element={<Map />} />
          <Route path="/utils" element={<TrainUtil />} />
          <Route path="/" element={<Navigate to="/title" replace />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
